import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/body-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/conditional-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/context/active-section-context.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/avatar.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/niceflix.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/saddamreels.png");
